import api from 'src/config/api';
import {
	IPatientAssetUploadRequest,
	IPatientAssetUploadResponse,
} from 'src/features/patient_asset/domain/types';

export const patientAssetApi = {
	uploadPatientAssets: async (
		requestBody: IPatientAssetUploadRequest[],
		siteSlug: string,
	): Promise<IPatientAssetUploadResponse[]> => {
		const formData = new FormData();

		const metaData: Omit<IPatientAssetUploadRequest, 'file_key'>[] = [];

		for (const obj of requestBody) {
			formData.append(obj.file_key, obj.file);

			metaData.push({
				patient_id: obj.patient_id,
				study_id: obj.study_id,
				file: obj.file_key,
				type: obj.type,
				source: obj.source,
				questionnaire_field_id: obj.questionnaire_field_id,
			});
		}

		formData.append('meta_data', JSON.stringify(metaData));

		const response = await api.post(`/api/v1/assets/upload`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Site: siteSlug,
			},
		});

		return response.data;
	},

	deletePatientAsset: async (
		assetId: number,
		siteSlug: string,
	): Promise<void> => {
		const response = await api.delete(`/api/v1/patient-asset/${assetId}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},
};
